import { useAppContext } from './context/AppContext';
import React, { useEffect, useState } from 'react';

const Dashboard = () => {
    const { userId, handleLogout, userType, users, notifications } = useAppContext();
    const [activeSection, setActiveSection] = useState(() => localStorage.getItem('activeSection') || 'dashboard');
    const isLoading = !userId || !userType;
    const [counts, setCounts] = useState({ clients: 0, projects: 0, tasks: 0, teams: 0 });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchCounts = async () => {
            setLoading(true);
            setError('');
            try {
                const [clientsRes, projectsRes, tasksRes, teamsRes] = await Promise.all([
                    fetch('/api/get-clients.php'),
                    fetch('/api/get-projects.php'),
                    fetch('/api/get-tasks.php'),
                    fetch('/api/get-teams.php'),
                ]);
                const clientsData = await clientsRes.json();
                const projectsData = await projectsRes.json();
                const tasksData = await tasksRes.json();
                const teamsData = await teamsRes.json();
                setCounts({
                    clients: (clientsData.clients || []).length,
                    projects: Array.isArray(projectsData) ? projectsData.length : (projectsData.projects || []).length,
                    tasks: Array.isArray(tasksData) ? tasksData.length : (tasksData.tasks || []).length,
                    teams: Array.isArray(teamsData) ? teamsData.length : (teamsData.teams || []).length,
                });
            } catch (err) {
                setError('Failed to load dashboard data.');
            }
            setLoading(false);
        };
        fetchCounts();
    }, []);

    if (isLoading) {
        return <div>Loading dashboard...</div>;
    }
    return (
        <div style={{ padding: 'var(--section-padding)' }}>
            <h1 style={{ color: 'var(--color-primary)', fontSize: '2.5rem', fontWeight: 700, marginBottom: '2rem' }}>Dashboard</h1>
            <button onClick={handleLogout}>Logout</button>
            {loading ? (
                <div>Loading dashboard...</div>
            ) : error ? (
                <div style={{ color: 'var(--color-error)' }}>{error}</div>
            ) : (
                <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'var(--color-surface)', borderRadius: 'var(--border-radius)', boxShadow: 'var(--box-shadow)', padding: '2rem', minWidth: 200, flex: 1 }}>
                        <h2 style={{ color: 'var(--color-primary)', fontSize: '2rem', margin: 0 }}>{counts.clients}</h2>
                        <div style={{ color: 'var(--color-text-light)', fontWeight: 600 }}>Clients</div>
                    </div>
                    <div style={{ background: 'var(--color-surface)', borderRadius: 'var(--border-radius)', boxShadow: 'var(--box-shadow)', padding: '2rem', minWidth: 200, flex: 1 }}>
                        <h2 style={{ color: 'var(--color-secondary)', fontSize: '2rem', margin: 0 }}>{counts.projects}</h2>
                        <div style={{ color: 'var(--color-text-light)', fontWeight: 600 }}>Projects</div>
                    </div>
                    <div style={{ background: 'var(--color-surface)', borderRadius: 'var(--border-radius)', boxShadow: 'var(--box-shadow)', padding: '2rem', minWidth: 200, flex: 1 }}>
                        <h2 style={{ color: 'var(--color-accent)', fontSize: '2rem', margin: 0 }}>{counts.tasks}</h2>
                        <div style={{ color: 'var(--color-text-light)', fontWeight: 600 }}>Tasks</div>
                    </div>
                    <div style={{ background: 'var(--color-surface)', borderRadius: 'var(--border-radius)', boxShadow: 'var(--box-shadow)', padding: '2rem', minWidth: 200, flex: 1 }}>
                        <h2 style={{ color: 'var(--color-success)', fontSize: '2rem', margin: 0 }}>{counts.teams}</h2>
                        <div style={{ color: 'var(--color-text-light)', fontWeight: 600 }}>Teams</div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Dashboard;
